<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand d-flex align-items-center" href="#">
      <img src="@/assets/images/madinah_logo.webp" alt="Logo" class="logo mr-2" />
    </a>
    <div class="navbar-content">
      <ul class="navbar-nav">
        <li class="nav-item active">
          <span class="nav-link">
            <img src="@/assets/images/navbar/calendar.png" />
            {{
              new Intl.DateTimeFormat(this.$i18n.locale == "ar" ? "ar-TN-u-ca-islamic" : "en-TN-u-ca-islamic", {
                day: "numeric",
                month: "long",
                year: "numeric",
              }).format(new Date())
            }}
          </span>
        </li>
        <li class="nav-item">
          <span class="nav-link">
            <img src="@/assets/images/navbar/clock.png" />
            {{
              this.$i18n.locale == "ar"
                ? new Intl.DateTimeFormat("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                  timeZone: "Asia/Kuala_Lumpur",
                })
                  .format(new Date())
                  .replace("AM", "ص")
                  .replace("PM", "م")
                : new Intl.DateTimeFormat("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                  timeZone: "Asia/Kuala_Lumpur",
                }).format(new Date())
            }}
            {{ $t("top_nav.timezone") }}
          </span>
        </li>
        <li class="nav-item temperature">
          <span class="nav-link">
            <img src="@/assets/images/navbar/temp.png" />
            {{ $t("top_nav.temperature") }} {{ temperature }}°C
          </span>
        </li>
      </ul>
      <span :class="'navbar-text ' + (this.$i18n.locale === 'ar' ? 'me-auto' : 'ms-auto')">
        <div class="d-flex flex-row">
          <div class="d-flex flex-row lang">
            <img src="@/assets/images/navbar/global.png" alt="" class="global" />
            <span @click="switchLanguage">{{
              this.$i18n.locale == "ar" ? "English" : "العربية"
            }}</span>
          </div>
          <div class="break"></div>
          <div class="d-flex flex-row">
            <img src="@/assets/images/navbar/ico1.png" class="fl_icons" />
            <img src="@/assets/images/navbar/ico2.png" class="fl_icons" />
            <img src="@/assets/images/navbar/ico3.png" class="fl_icons" />
          </div>
        </div>
      </span>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      temperature: null,
      country: "Malaysia", // Default country
    };
  },
  async created() {
    await this.getUserCountry();
    await this.getTemperature();
  },
  methods: {
    switchLanguage() {
      const newLocale = this.$i18n.locale === "ar" ? "en" : "ar";
      this.$i18n.locale = newLocale;
      localStorage.setItem("locale", newLocale); // Save to localStorage
      document.body.setAttribute("dir", newLocale === "ar" ? "rtl" : "ltr");
    },
    async getUserCountry() {
      try {
        const response = await fetch("https://ipapi.co/json/");
        const data = await response.json();
        this.country = data.country_name; // Get user's country
      } catch (error) {
        console.error("Error getting user country:", error);
      }
    },
    async getTemperature() {
      const apiKey = "9a33fccf03034e91ad655034252203"; // Replace with your WeatherAPI key
      const apiUrl = `https://api.weatherapi.com/v1/current.json?key=${apiKey}&q=${this.country}&aqi=no`;

      try {
        const response = await fetch(apiUrl);
        const data = await response.json();
        this.temperature = data.current.temp_c; // Get temperature in Celsius
      } catch (error) {
        console.error("Error fetching weather data:", error);
      }
    },
  },
};
</script>

<style scoped>
.logo {
  height: 57px;
}

.navbar-content {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.nav-link {
  font-size: 18px;
  font-weight: 300;
}

.fl_icons {
  padding-inline-end: 7px;
  height: 20px;
  width: auto;
  cursor: pointer;
  position: relative;
  top: 2px;
}

.navbar-text {
  margin-inline-end: 40px;
}

.break {
  width: 2px;
  height: 25px;
  background-color: #39373533;
  margin-inline-end: 10px;
}

.lang {
  margin-inline-end: 10px;
  cursor: pointer;
}

.lang span {
  color: #393735;
  font-size: 18px;
  font-weight: 400;
  margin-inline-start: 4px;
}

.lang span:hover {
  color: #bf9f35;
}

.global {
  height: 24px;
  position: relative;
  top: 2px;
}

/* Hide temperature on mobile */
@media (max-width: 768px) {
  .temperature {
    display: none;
  }
  .navbar-content {
    flex-direction: column;
    padding-inline-start: 10px;
  }

  .navbar-text {
    margin-left: 0 !important;
    margin-right: 0 !important;
    display: flex;
    flex-direction: column;
    align-items: center; /* Ensure it stays centered */
  }

}
</style>
